export default __webpack_public_path__ + "static/media/sucesss_page.580f5cfa.png";